export const debounce = (func: (...args: any[]) => any, wait: number, immediate = false) => {
    let timeout: any;

    return function() {
        const context = this;
        const args = arguments;

        const later = () => {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };

        const callNow = immediate && !timeout;
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
};

export const isCallable = (object: any) => {
    return typeof object === "function";
};

export function isPresent<T>(t: T | undefined | null | void): t is T {
    return t !== undefined && t !== null;
}
